import { space } from '@sunwebgroup/ui-components'
import { Button, Typography } from '@sunwebgroup/ui-components/uds'
import * as React from 'react'
import { styled } from 'styled-components'

interface EmptyStateProps {
  title: string
  description: string
  confirmationText?: string
  onConfirmClick?: React.MouseEventHandler
}

const Wrapper = styled.div`
  display: flex;
  flex: 1 1 0%;
  padding: ${space('primitives_space_16')};
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;

  ${Button} {
    margin-top: ${space('primitives_space_16')};
  }
`

export function EmptyState({ title, description, confirmationText, onConfirmClick }: EmptyStateProps) {
  return (
    <Wrapper>
      <Typography forwardedAs="p" variant="body-l-bold-snug">
        {title}
      </Typography>
      <Typography variant="body-m-regular-snug" forwardedAs="p">{description}</Typography>
      {confirmationText && (
        <Button variant="secondary" onClick={onConfirmClick}>
          {confirmationText}
        </Button>
      )}
    </Wrapper>
  )
}
